import { Injectable } from '@angular/core';
import { MyInformationService } from '@app/shared/services/my-information/my-information.service';
import { OfficeService } from '@app/shared/services/office/office.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { RootStoreState } from '..';
import * as myInformationActions from './actions';

@Injectable()
export class MyInformationStoreEffects {
  user;
  myInformationObject = this.store$.select('MyInformation');
  constructor(
    private myInformationService: MyInformationService,

    private action$: Actions,
    private store$: Store<RootStoreState.State>
  ) {}

  getRootFolders$: Observable<any>  = createEffect(() => 
   this.action$.pipe(
    ofType<myInformationActions.GetRootFolderRequest>(myInformationActions.ActionTypes.GET_ROOT_FOLDER_REQUEST),
    switchMap((action: any) => {
      return this.myInformationService.getRootFolders(action.payload).pipe(
        map((data) => {
          return new myInformationActions.GetRootFolderSuccessAction(data.data);
        }),
        catchError((error) => {
          return of(new myInformationActions.GetRootFolderFailureAction(error));
        })
      );
    })
   )
  );
}
